__turbopack_context__.v({
  "bullet": "UspsOverview-module-scss-module__kDTy8q__bullet",
  "bullet-wrapper": "UspsOverview-module-scss-module__kDTy8q__bullet-wrapper",
  "extras": "UspsOverview-module-scss-module__kDTy8q__extras",
  "usp-card": "UspsOverview-module-scss-module__kDTy8q__usp-card",
  "usps": "UspsOverview-module-scss-module__kDTy8q__usps",
});
